import React from "react";
import logo from '../Assests/pet.jpg';
import header from '../Assests/header.PNG';
import bottom from '../Assests/bottom.PNG';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from "@mui/material";
import { ref } from "yup";

export default class DailyStockReportFile extends React.Component {
    render() {
        const salesDetailList = this.props.salesDetailList;

        return (
            <div>
                {/* Header Section */}
                <div className="header">
                    <img
                        src={header}
                        height="auto"
                        width="100%"
                        alt="Header Logo"
                    />
                </div>


                {/* Table Section */}
                <div className="print-content">
                    {/* Title */}
                    <br />
                    <h2 style={{ textAlign: 'center' }}>Daily Sales Details Report</h2>
                    <hr />
                    <br />
                    <Box minWidth={1050}>
                        <TableContainer>
                            <Table sx={{ minWidth: 500, pageBreakInside: 'auto' }} aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>#</TableCell>
                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Invoice Number</TableCell>
                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Item Name</TableCell>
                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Unit Price</TableCell>
                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Quanity</TableCell>
                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Total Amount (Rs.)</TableCell>
                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Sales Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {salesDetailList.map((row, index) => (
                                        <TableRow key={row._id} sx={{ pageBreakInside: 'avoid' }}>
                                            <TableCell align='left'>{index + 1}</TableCell>
                                            <TableCell align='left'>{row.inv_no}</TableCell>
                                            <TableCell align='left'>{row.item_name}</TableCell>
                                            <TableCell align='left'>{row.unitprice}</TableCell>
                                            <TableCell align='left'>{row.total_quantity}</TableCell>
                                            <TableCell align='left'>{row.total_amount}</TableCell>
                                            <TableCell align='left'>{row.creation_date}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>

                {/* Footer Section */}
                {/* <div className="footer">
                    <img
                        src={bottom}
                        height="auto"
                        width="100%"
                        alt="Footer Logo"
                        style={{ bottom: 0 }}
                    />
                </div> */}

                {/* Print-specific CSS */}
                <style jsx="true">
                    {`
                                @media print {
                                    @page {
                                        size: A4;
                                        margin: 5mm;
                                    }
        
                                    body {
                                        margin: 0;
                                        -webkit-print-color-adjust: exact;
                                    }
        
                                    .header {
                                        position: relative;
                                        top: 0;
                                        width: 100%;
                                    }
                                }
                            `}
                </style>
            </div>
        );
    }
}